<div class="locationGridCell" *ngrxLet="viewModel$; let viewModel">
  @if (!viewModel.loading) {
    <span [ngClass]="{ 'text-neutral-60': viewModel.isFieldBlacklisted }">{{ viewModel?.value | split:viewModel.splitSeparator |
    join:viewModel.joinSeparator }}</span>
  }
  @if (viewModel.loading) {
    <ngx-skeleton-loader
      class="w-full"
      [theme]="{ marginBottom: 0 }"></ngx-skeleton-loader>
  }
</div>

